<template>
  <div class="files">
    <div class="files_title">
      <div class="files_title_value">原材料附件</div>
      <div class="btns">
        <Button type="ghost" shape="circle" class="upload" :loading="isUploading" icon="ios-search" @click.prevent="upload"><span>上传附件</span></Button>
        <input type="file" ref="fileInput" @change="fileChange($event)" multiple="multiple" class="upload-input">
      </div>
    </div>
    <div class="files_values">
      <ul class="list clearfix" v-if="list.length > 0">
        <li v-for="(item, index) in list" :key="index">
          <div :class="{thumb: true, active: item.active}" @mouseover.stop.prevent="selectStyle(item)" @mouseout.stop.prevent="outStyle(item)">
            <img :src="$options.filters.getFileImage(item.name)"/>
            <div class="del" title="点击删除" @click.stop.prevent="delFile(item._id)">
              <img src="~@/assets/images/coo/icon_shanchu.png">
              <div>删除</div>
            </div>
          </div>
          <div class="name" @click.prevent="onDownload(item.url)" :title="`点击下载 ${item.name || '未命名'}`">{{item.name | getFileName}}</div>
        </li>
      </ul>
      <div class="empty" v-else>暂无原材料附件</div>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Vue from 'vue'
import Loader from '@/components/layout/Loader'
// import defaultAvatar from '@/assets/images/default_avatar.png'

export default {
  name: 'RulesDecideFileUpload',
  components: { Loader },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      isUploading: false,
      isShowLoader: false,
      list: []
    }
  },
  watch: {
    dataSet (newVal, oldVal) {
      if (newVal && newVal.id) {
        if (newVal.files && newVal.files.length > 0) {
          this.list = this._.map(newVal.files, item => {
            item['_id'] = this._h.getRandomStr(32)
            return item
          })
        } else {
          this.list = []
        }
      }
    }
  },
  filters: {
    getFileImage (name) {
      name = Vue._.trim(name)
      if (!name) return require('@/assets/images/coo/files/wenjian.png')
      let suffix = Vue._h.getSuffix(name)
      let image = require('@/assets/images/coo/files/wenjian.png')
      switch (suffix.toLocaleLowerCase()) {
        case '.docx':
        case '.doc':
          image = require('@/assets/images/coo/files/word.png')
          break
        case '.xlsx':
        case '.xls':
          image = require('@/assets/images/coo/files/excel.png')
          break
        case '.pdf':
          image = require('@/assets/images/coo/files/pdf.png')
          break
        case '.gif':
        case '.bmp':
        case '.png':
        case '.jpeg':
        case '.jpg':
          image = require('@/assets/images/coo/files/jpg.png')
          break
      }
      return image
    },
    getFileName (name) {
      name = Vue._.trim(name)
      if (!name) return '未命名'
      let suffix = Vue._h.getSuffix(name)
      let _name = name.replace(suffix, '')
      return Vue._.truncate(_name, {
        length: 6,
        omission: '.'
      }) + suffix
    }
  },
  methods: {
    addFile (name, url) {
      this.list.push({ _id: this._h.getRandomStr(32), name: name, url: url })
    },
    delFile (_id) {
      if (this.isShowLoader) return false
      if (_id) {
        this.GConfirm('确定删除此文件？', status => {
          if (status) {
            this.isShowLoader = true
            this.$Loading.start()
            this.list = this._.filter(this.list, item => item._id !== _id)
            this.saveFiles()
          }
        })
      } else {
        this.$Message.warning({content: '文件ID不存在，请重试', closable: true})
      }
    },
    saveFiles () {
      if (this.list.length >= 0) {
        this.$api.coo.goods.uploadAttachment(this.dataSet.id, { files: this.list }, {
          success: response => {
            this.$Message.destroy()
            if (response.data.code === 200) {
              this.$Loading.finish()
              this.$Message.success({ content: '原材料附件更新成功', closable: true })
            } else {
              this.$Loading.error()
              this.$Message.warning({content: '原材料附件更新失败，请重试！', closable: true})
            }
            this.isShowLoader = false
            this.isUploading = false
          },
          error: errorMsg => {
            this.$Loading.error()
            this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
            this.isShowLoader = false
            this.isUploading = false
          }
        })
      } else {
        this.$Loading.finish()
        this.isShowLoader = false
        this.isUploading = false
        this.$Message.destroy()
        this.$Message.info({content: '请上传附件', closable: true})
      }
      this.$refs.fileInput.value = null
    },
    uploadFileToAzure (file, sas, container, fileIndex, callback) {
      let fileName = this._h.getRandomStr(15)
      let suffix = this._h.getSuffix(file.name)
      let azureName = 'smartftax'
      let blobUri = `https://${azureName}.blob.core.chinacloudapi.cn`
      let blobService = this.$AzureStorage.createBlobServiceWithSas(blobUri, sas)
      blobService.createBlockBlobFromBrowserFile(container, `${fileName}${suffix}`, file, (error, result) => {
        if (!error) {
          this.addFile(file.name, `${blobUri}/${container}/${fileName}${suffix}`)
        } else {
          this.$Message.error({content: `文件 ${file.name} 上传失败，请重新上传此文件`, closable: true})
        }
        if (callback && typeof callback === 'function') {
          callback(fileIndex)
        }
      })
    },
    uploadFilesCallback (files, sas, container, index) {
      if (index === files.length) {
        this.saveFiles()
      } else {
        this.uploadFileToAzure(files[index], sas, container, index + 1, fileIndex => {
          this.uploadFilesCallback(files, sas, container, fileIndex)
        })
      }
    },
    uploadFiles (files) {
      if (!files || files.length === 0) return
      let isRefused = false
      this._.each(files, file => {
        if (file.size > 50 * 1024 * 1024) {
          this.$Message.error({content: '上传文件过大，请上传不超过50M的文件', closable: true})
          isRefused = true
          return false
        }
        let suffix = this._h.getSuffix(file.name)
        if (this._.indexOf(['.pdf', '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.wps', '.et', '.rar', '.zip', '.7z', '.iso', '.tar', '.gz', '.bz2', '.z'], suffix) === -1) {
          this.$Message.error({content: '上传文件类型错误', closable: true})
          isRefused = true
          return false
        }
      })
      if (isRefused) {
        this.$refs.fileInput.value = null
        return false
      }
      this.isUploading = true
      this.isShowLoader = true
      let container = 'content'
      this.$Loading.start()
      this.$api.getSasToken(container, {
        success: response => {
          if (response.data.code === 200) {
            let sas = response.data.data.sas
            // this._.forEach(files, (file, index) => {})
            this.uploadFilesCallback(files, sas, container, 0)
          } else {
            this.$Loading.error()
            this.$Message.error({content: this.$t('common.uploadSasError2'), closable: true})
            this.isUploading = false
            this.isShowLoader = false
            this.$refs.fileInput.value = null
          }
        },
        error: errorMsg => {
          this.$Loading.error()
          this.$Message.error({content: this.$t('common.uploadSasError'), closable: true})
          this.isUploading = false
          this.isShowLoader = false
          this.$refs.fileInput.value = null
        }
      })
    },
    upload () {
      if (!this.isUploading) {
        this.$refs.fileInput.click()
      }
    },
    fileChange (event) {
      const files = event.target.files
      if (!files || files.length === 0) return
      this.uploadFiles(files)
    },
    onDownload (url) {
      window.open(url, '_blank')
    },
    selectStyle (item) {
      this.$nextTick(() => {
        this.list.forEach(_item => {
          this.$set(_item, 'active', false)
        })
        this.$set(item, 'active', true)
      })
    },
    outStyle (item) {
      this.$set(item, 'active', false)
    }
  }
}
</script>
<style scoped>
  .upload-input{
    display: none;
  }
  .files{
    /* box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50); */
    position: relative;
  }
  .files >>> .loading .wrap{
    top: 6px;
    /*left: 120px;*/
    /*transform: translateX(0);*/
  }
  .files_title{
    position: relative;
    height: 48px;
    line-height: 48px;
    background-color: #F9F9F9;
  }
  .files_title .files_title_value{
    font-size: 15px;
    color: #333;
    background: url("~@/assets/images/home/guide.png") 15px center no-repeat transparent;
    background-size: 12px;
    padding-left: 34px;
  }
  .btns{
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  .btns >>> .ivu-btn{
    border-radius: 100px;
    width: 130px;
    padding-top: 5px;
    padding-bottom: 5px;
    background-color: #fff;
    font-size: 14px;
  }
  .btns >>> .ivu-btn .ivu-icon-ios-search{
    background: url("~@/assets/images/coo/icon_dr.png") 0 center no-repeat transparent;
    background-size: 12px 12px;
    width: 12px;
    height: 12px;
    position: relative;
    top: 1px;
  }
  .btns >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
    margin-left: 2px;
  }
  .btns >>> .ivu-btn .ivu-icon-ios-search:before{
    content: "";
  }
  .btns .upload{
    border: 1px solid #00B55F;
    color: #00B55F;
  }
  .files_values{
    padding: 25px 15px 15px;
  }
  .files_values .empty{
    /*font-style: italic;*/
    color: #999;
    font-size: 15px;
  }
  .files_values .list{
    margin-left: 0px;
    margin-right: -20px;
    display: flex;
    flex-wrap: wrap;
  }
  .files_values .list li{
    /*float: left;*/
    text-align: center;
    margin: 0 35px 30px 0;
    width: 112px;
  }
  .files_values .list li .thumb{
    position: relative;
    width: 54px;
    margin: 0 auto;
  }
  .files_values .list li .thumb img{
    width: 54px;
    display: block;
    margin: 0 auto;
  }
  .files_values .list li .thumb .del{
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    display: none;
  }
  .files_values .list li .thumb.active .del{
    display: flex;
  }
  .files_values .list li .thumb .del img{
    width: 18px;
    height: 18px;
  }
  .files_values .list li .thumb .del div{
    color: #fff;
    font-size: 11px;
    margin-top: 2px;
  }
  .files_values .list li .name{
    margin-top: 8px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/FileUpload.vue